export default function YoutubeIcon({ width = 38, height = 27, className, style }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 38 27"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <path
                d="M36.9893 5.09961C36.6748 2.37891 36.0186 1.58594 35.5537 1.2168C34.8154 0.642577 33.4756 0.4375 31.6846 0.314454C28.8135 0.123047 23.9326 0 18.6689 0C13.3916 0 8.52441 0.109375 5.65332 0.314454C3.8623 0.4375 2.52246 0.642577 1.78418 1.2168C1.31934 1.58594 0.676758 2.37891 0.348633 5.09961C-0.116211 9.02344 -0.116211 17.9648 0.348633 21.8887C0.676758 24.6094 1.31934 25.4023 1.78418 25.7715C2.52246 26.3457 3.8623 26.5508 5.65332 26.6738C8.52441 26.8652 13.3916 26.9883 18.6689 26.9883C23.9463 26.9883 28.8135 26.8652 31.6846 26.6738C33.4756 26.5508 34.8154 26.3457 35.5537 25.7715C36.0186 25.416 36.6611 24.6094 36.9893 21.8887C37.4541 17.9648 37.4541 9.02344 36.9893 5.09961ZM14.1572 19.3594V7.61523L25.4229 13.4805L14.1572 19.3594Z"
                fill="#EAEAEA"
            />
        </svg>
    );
}
